package com.eladfinish.bible.contest.features.installTime.domain.config

data class TimeGateConfig(
    val enabled: Boolean = true,

    /**
     * Minutes since first install required to pass the gate.
     * Example: 1440 (24h), 2880 (48h)
     */
    val minutesSinceInstall: Int = 1440,

    /**
     * Minutes since last update required to pass the gate.
     * 0 = ignore update time.
     */
    val minutesSinceUpdate: Int = 0,
)
